import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { processSession } = useAuth();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleCallback = async () => {
      if (hasProcessed.current) return;
      hasProcessed.current = true;

      // Extract session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          await processSession(sessionId);
          setStatus('success');
          
          // Force a full page reload to ensure all components update
          // This ensures the navbar shows the user profile
          setTimeout(() => {
            window.location.href = '/';
          }, 500);
          
        } catch (error) {
          console.error('Auth callback error:', error);
          setStatus('error');
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        }
      } else {
        setStatus('error');
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    };

    handleCallback();
  }, [location.hash, processSession]);

  return (
    <div className="min-h-screen bg-[#1a1f2e] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#d4a33a] animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">
          {status === 'processing' && 'جاري تسجيل الدخول...'}
          {status === 'success' && '✓ تم تسجيل الدخول بنجاح!'}
          {status === 'error' && 'حدث خطأ، جاري إعادة التوجيه...'}
        </p>
        {status === 'success' && (
          <p className="text-[#d4a33a] text-sm mt-2">جاري تحويلك...</p>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
